// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".revico-widget .revico-community-talk-details-user {\n  display: flex;\n  width: 100%;\n  margin-bottom: 8px;\n  position: relative;\n}\n.revico-widget .revico-community-talk-details-user-left + .revico-widget .revico-community-talk-details-user-right {\n  margin-left: 8px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
